import { Component, Vue, Prop } from 'vue-property-decorator';
import Loader from '@/components/Loader/index.vue';
import MessageError from '@/components/edit/MessageError/index.vue';
import IndicatorOpenPortal from '@/components/edit/IndicatorOpenPortal/index.vue';
import searchHelper from '@/helpers/search';
import tableHelper from '@/helpers/table';
import vSelect from 'vue-select';

Vue.component('v-select', vSelect);

@Component({
	components: {
		Loader,
		MessageError,
	},
})
export default class SelectPortal extends Vue {
	@Prop({ required: true }) readonly options;
	@Prop({ default: '' }) readonly placeholder;
	@Prop({ default: 'name' }) readonly label;
	@Prop({ default: false }) readonly multiple;
	@Prop({ default: false }) readonly user;
	@Prop() readonly value;

	selected: object[] | object | null = null;

	created() {
		if (this.multiple) {
			this.selected = this.selected || [];
			this.selected = (this.selected as object[]).concat(this.value);
		} else {
			this.selected = this.value || [];
		}
	}

	OpenIndicator = IndicatorOpenPortal;

	clearSearchOnBlur() {
		return true;
	}

	onInput(val) {
		this.$emit('input', val);
	}

	onBlur() {
		this.$emit('blur');

		if (this.multiple) {
			const el: HTMLInputElement | null = document.getElementsByClassName('vs__search')[0] as HTMLInputElement;

			if (el.value) {
				(this.selected as object[]).push({
					label: el.value,
				});
			}
		}
	}

	search(options, search) {
		return options.filter((option) => {
			return searchHelper
				.search(option.name || option.cnj, search);
		});
	}

	formatCNJ(val) {
		return tableHelper.formatCNJ(val);
	}
}
